/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-08-14 15:31:19
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { flatten } from "lodash";
import { ceilNumber, toVisualThousands } from "../utils";
import { FONT_FAMILY, labelFont, xAxisLabelColor } from "../visualConfig";

const createGrid = (list = []) => {
  const len = list.length;
  const width = (1210 - 80) / len;
  
  return list.map((_, index) => ({
    id: index,
    top: 50,
    width: width,
    bottom: 80,
    left: index * width + 80,
    containLabel: false,
  }));
};

const createXAxis = (list = []) => {
  return list.map((item, index) => ({
    name: item.name,
    gridIndex: index,
    nameLocation: 'center',
    nameTextStyle: {
      padding: [50, 0, 0, 0],
      fontWeight: 500,
      ...xAxisLabelColor,
    },
    type: 'category',
    axisLabel: {
      interval: 0,
      fontWeight: 500,
      show: true,
      rotate: 90,
      ...xAxisLabelColor,
    },
    // axisLine: { show: false },
    axisTick: {
      show: true,
      length: 70,
      interval: index => index === item.list.length - 1,
    },
    // minorTick: { show: false },
    // splitLine: { show: false },
    // splitNumber: 4,
    data: item.list.map(ele => ele.name),
  }));
}

const createYAxis = (list = []) => {
  const data = flatten(list.map(item => item.list)).map(item => item.value)
  const max = Math.max(...data);

  return list.map((item, index) => ({
    type: 'value',
    name: '数字品牌价值（单位：{db|DB}）',
    nameTextStyle: {
      fontSize: 16,
      fontWeight: 'bold',
      color: '#000',
      padding: [0, 0, 0, 40],
      rich: {
        db: {
          fontSize: 16,
          fontStyle: 'italic'
        }
      },
    },
    gridIndex: index,
    show: index === 0,
    max: ceilNumber(max),
    axisLabel: {
      fontFamily: FONT_FAMILY,
      color: '#000',
    },
    axisLine: { show: false },
    splitLine: { show: false },
  }));
}

const createSeries = (list = [], color = []) => {
  return list.map(({ name, list }, index) => ({
    xAxisIndex: index,
    yAxisIndex: index,
    type: 'bar',
    name: name,
    label: {
      show: true,
      position: 'top',
      fontFamily: FONT_FAMILY,
      formatter: (ele) => toVisualThousands(ele.value),
      ...labelFont,
    },
    data: list.map((item, i) => ({
      ...item,
      itemStyle: { color: color[i] },
      // emphasis: { itemStyle },
    })),
  }));
}

export default  ({ list = [], color = [] }) => {
  return {
    title: {},
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: { show: false },
    grid: createGrid(list),
    xAxis: createXAxis(list),
    yAxis: createYAxis(list),
    series: createSeries(list, color)
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P16/chart.js